export default __webpack_public_path__ + "static/media/team-2.5e9231fd.png";